import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: MainLayout,
    meta: { component: 'Dashboard' }
  },
  {
    path: '/trainers',
    name: 'trainers',
    component: MainLayout,
    meta: { component: 'Trainers' }
  },
  {
    path: '/groups',
    name: 'groups',
    component: MainLayout,
    meta: { component: 'Groups' }
  },
  {
    path: '/students',
    name: 'students',
    component: MainLayout,
    meta: { component: 'Students' }
  },
  { 
    path: '/students/:id', 
    name: 'current-student',
    component: MainLayout,
    meta: { component: 'CurrentStudent' }
  },
  {
    path: '/transaction-log',
    name: 'transaction-log',
    component: MainLayout,
    meta: { component: 'TransactionLog' }
  },
  {
    path: '/locations',
    name: 'locations',
    component: MainLayout,
    meta: { component: 'Locations' }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: MainLayout,
    meta: { component: 'Calendar' }
  },
  {
    path: '/incomes',
    name: 'incomes',
    component: MainLayout,
    meta: { component: 'Incomes' }
  },
  {
    path: '/incomes/tx_id/:tx_id',
    name: 'incomesWithCurrentTxId',
    component: MainLayout,
    meta: { 
      component: 'Incomes' 
    }
  },
  {
    path: '/incomes/balance_id/:balance_id',
    name: 'incomesWithCurrentBalanceId',
    component: MainLayout,
    meta: { 
      component: 'Incomes' 
    }
  },
  {
    path: '/outlays',
    name: 'outlays',
    component: MainLayout,
    meta: { component: 'Outlays' }
  },
  {
    path: '/outlays/tx_id/:tx_id',
    name: 'outlaysWithCurrentTxId',
    component: MainLayout,
    meta: { 
      component: 'Outlays' 
    }
  },
  {
    path: '/outlays/balance_id/:balance_id',
    name: 'outlaysWithCurrentBalanceId',
    component: MainLayout,
    meta: { 
      component: 'Outlays' 
    }
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: MainLayout,
    meta: { component: 'Transactions' }
  },
  {
    path: '/transactions/tx_id/:tx_id',
    name: 'transactionsWithCurrentTxId',
    component: MainLayout,
    meta: { 
      component: 'Transactions' 
    }
  },
  {
    path: '/transactions/balance_id/:balance_id',
    name: 'transactionsWithCurrentBalanceId',
    component: MainLayout,
    meta: { 
      component: 'Transactions' 
    }
  },
  {
    path: '/admins',
    name: 'adminsView',
    component: MainLayout,
    meta: { 
      component: 'Admins' 
    }
  },
  {
    path: '/outlays-categories',
    name: 'OutlaysCategories',
    component: MainLayout,
    meta: { 
      component: 'OutlaysCategories' 
    }
  },
  {
    path: '/club-outlays',
    name: 'ClubOutlays',
    component: MainLayout,
    meta: { 
      component: 'ClubOutlays' 
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: MainLayout,
    meta: { 
      component: 'Settings' 
    }
  },

  // Training Summaries
  {
    path: '/training-constructor',
    name: 'TrainingConstructor',
    component: MainLayout,
    meta: { 
      component: 'TrainingConstructor' 
    }
  },
  {
    path: '/training-programs',
    name: 'TrainingPrograms',
    component: MainLayout,
    meta: { 
      component: 'TrainingPrograms' 
    }
  },
  {
    path: '/training-schemes',
    name: 'TrainingSchemes',
    component: MainLayout,
    meta: { 
      component: 'TrainingSchemes' 
    }
  },
  {
    path: '/training-schemes/:element_id',
    name: 'AddingSchemaToElement',
    component: MainLayout,
    meta: { 
      component: 'TrainingSchemes' 
    }
  },
  {
    path: '/training-elements',
    name: 'TrainingElements',
    component: MainLayout,
    meta: { 
      component: 'TrainingElements' 
    }
  },
  {
    path: '/trainings-constructor',
    name: 'TrainingsConstructor',
    component: MainLayout,
    meta: { 
      component: 'Trainings' 
    }
  },
  {
    path: '/training-program',
    name: 'TrainingProgramView',
    component: MainLayout,
    meta: { 
      component: 'TrainingProgramView' 
    }
  },
  {
    path: '/new-training-element',
    name: 'ElementForm',
    component: MainLayout,
    meta: { 
      component: 'ElementForm' 
    }
  },
  {
    path: '/training-creation-form',
    name: 'TrainingCreationForm',
    component: MainLayout,
    meta: { 
      component: 'TrainingCreationForm' 
    }
  },  
  {
    path: '/training-element/:id',
    name: 'ElementUpdateForm',
    component: MainLayout,
    meta: { 
      component: 'ElementUpdateForm' 
    }
  },
  {
    path: '/training-summary/:id',
    name: 'TrainingUpdateForm',
    component: MainLayout,
    meta: { 
      component: 'TrainingUpdateForm' 
    }
  },
  {
    path: '/create-training-program',
    name: 'TrainingProgramCreationForm',
    component: MainLayout,
    meta: { 
      component: 'TrainingProgramCreationForm' 
    }
  },
  {
    path: '/training-summary-addons',
    name: 'TrainingSummaryAddons',
    component: MainLayout,
    meta: { 
      component: 'TrainingSummaryAddons' 
    }
  },
  {
    path: '/training-program/:id',
    name: 'TrainingProgramUpdateForm',
    component: MainLayout,
    meta: { 
      component: 'TrainingProgramUpdateForm' 
    }
  },

  {
    path: '/player-summary-report/:student_id',
    name: 'PlayerSummaryScoutReportForm',
    component: MainLayout,
    meta: { 
      component: 'PlayerSummaryScoutReportForm' 
    }
  },
  {
    path: '/player-summary-report-view/:report_id',
    name: 'PlayerScoutSummaryReportView',
    component: MainLayout,
    meta: { 
      component: 'PlayerScoutSummaryReportView' 
    }
  },
  {
    path: '/schemas-table',
    name: 'SchemasTable',
    component: MainLayout,
    meta: { 
      component: 'SchemasTable' 
    }
  },
  {
    path: '/standard-constructor',
    name: 'StandardConstructor',
    component: MainLayout,
    meta: { 
      component: 'StandardConstructor' 
    }
  },

  {
    path: '/testing',
    name: 'Testing',
    component: MainLayout,
    meta: { 
      component: 'TestingView' 
    }
  },
  {
    path: '/testing/:group_id',
    name: 'TestingGroup',
    component: MainLayout,
    meta: { 
      component: 'TestingGroup' 
    }
  },
  {
    path: '/testing/:group_id/:testing_id',
    name: 'CurrentTesting',
    component: MainLayout,
    meta: { 
      component: 'CurrentTesting' 
    }
  },
  {
    path: '/testing/:group_id/:testing_id/:report_id',
    name: 'CurrentReport',
    component: MainLayout,
    meta: { 
      component: 'CurrentReport' 
    }
  },
  {
    path: '/testing/personal/:player_id/:base_standard_id',
    name: 'CurrentPlayerReports',
    component: MainLayout,
    meta: { 
      component: 'CurrentPlayerReports' 
    }
  },
  {
    path: '/analytics',
    name: 'AnalyticsView',
    component: MainLayout,
    meta: { 
      component: 'AnalyticsView' 
    }
  },

  {
    path: '/player-standards/:player_id',
    name: 'PlayerStandards',
    component: MainLayout,
    meta: { 
      component: 'NewFullStudentCard' 
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
